import { createFileRoute, useParams } from "@tanstack/react-router";
import { TaskDetailPage } from "@/components/task/TaskDetailPage";

export const Route = createFileRoute("/user/_layout/crm/tasks_/$id")({
  component: CrmMyTaskDetail,
});

function CrmMyTaskDetail() {
  const { id } = useParams({ from: "/user/_layout/crm/tasks_/$id" });
  return (
    <TaskDetailPage
      taskId={Number(id)}
      isAdmin={false}
      isCrm={true}
      backTo="/user/crm/tasks"
      
    />
  );
}
